import { getDay } from 'date-fns';
import { Day, DayShort } from '@/types';

export const daysOfTheWeek: Day[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const daysOfTheWeekShort: DayShort[] = daysOfTheWeek.map((e) => e.toLowerCase().substring(0, 3) as DayShort);

/**
 * Function to determine the order of the elements
 * @param dayA: {DayShort}
 * @param dayB: {DayShort}
 * @return {number}
 */
export function sortByShortDaysFn(dayA: DayShort, dayB: DayShort): number {
  return daysOfTheWeekShort.indexOf(dayA) - daysOfTheWeekShort.indexOf(dayB);
}

/**
 * Return day of the week
 * @param shortDay: {DayShort}
 * @return {Day}
 */
export function fullDayName(shortDay: DayShort): Day {
  return daysOfTheWeek[daysOfTheWeekShort.indexOf(shortDay)];
}
/**
 * Return true if incoming day is today
 * @param shortDay: {DayShort}
 * @return {Day}
 */
export function isCurrentDay(shortDay: DayShort): boolean {
  return shortDay === daysOfTheWeekShort[getDay(Date.now())];
}

/**
 * Convert ISO date string to date with no offset
 * @param date: {String}
 * @return {Date}
 */
export function ISOStringToLocalDate(date: string): Date {
  return new Date(date.replace(/Z$/, ''));
}
